import React from 'react';
import { Link } from 'react-router-dom';
import { Lightbulb, Code, Users, Mail } from 'lucide-react';

const CompanyFooter = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/logo.png" alt="Research and Innovation Studios" className="w-8 h-8" />
              <span className="text-xl font-bold">Research & Innovation Studios</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Pioneering innovative solutions through cutting-edge research and development. 
              We create transformative technologies that shape the future.
            </p>
            <div className="flex items-center space-x-2 text-gray-300">
              <Mail className="w-4 h-4" />
              <span>researchandinnovationstudios@gmail.com</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/bulk-leads-caller" className="text-gray-300 hover:text-white transition-colors">Projects</Link>
              </li>
              <li>
                <a href="#about" className="text-gray-300 hover:text-white transition-colors">About</a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-white transition-colors">Contact</a>
              </li>
            </ul>
          </div>

          {/* Our Values */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Values</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-gray-300">
                <Lightbulb className="w-4 h-4" />
                <span>Innovation</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-300">
                <Code className="w-4 h-4" />
                <span>Research</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; 2025 Research and Innovation Studios. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default CompanyFooter;
